import React from 'react';

import * as SchemaFieldConstants from 'schemas/fields/SchemaFieldConstants';
import * as InventoryFileConstants from 'inventory/InventoryFileConstants';

import HoistedTagNameBadge from './HoistedTagNameBadge';

export default function HoistedTagNameCell(props) {
  return (
    <div className="metadata-field-row">
      <div className="metadata-field-col">
        <div>
          <span className="u-mini-spacing-right">{props.tag.name}</span>
          <HoistedTagNameBadge tagSchemaGraph={props.tagSchemaGraph} />
        </div>
      </div>
    </div>
  );
}

HoistedTagNameCell.propTypes = {
  tag: InventoryFileConstants.HOISTED_TAG.isRequired,
  tagSchemaGraph: SchemaFieldConstants.TAG_SCHEMA_GRAPH.isRequired,
};
